import { Grid, Divider } from "@mui/material";
import { TitledSection } from "components/Classifiers/Common/TitledSection";
import { AnswerColor } from "components/UI/AcxAnswerSelector";
import React from "react";
import { ErrorResult } from "./ErrorResult";
import { TestLLMClassifierAgreementResult } from "models/LLMs/Testing/TestLLMClassifierAgreementResult";
import { ResultBadge } from "../ResultBadge";
import { getFriendlyId } from "../utils";

interface ErrorResultsSectionProps {
    results: TestLLMClassifierAgreementResult[];
}

export function ErrorResultsSection({ results }: ErrorResultsSectionProps) {
    if (results.length === 0) return null;

    return (
        <TitledSection
            id={getFriendlyId("errors")}
            title={
                <ResultBadge color={AnswerColor.RED}>
                    Errors ({results.length})
                </ResultBadge>
            }
            variant="bordered"
            collapsible
            sx={(theme) => ({
                borderLeft: `4px solid ${theme.palette.red.main}`,
            })}
        >
            <Grid container direction="column" flexWrap="nowrap" rowGap={2}>
                {results.map((result, number) => (
                    <React.Fragment key={result.conversation.id + number}>
                        <ErrorResult result={result} number={number} />
                        {number !== results.length - 1 && <Divider />}
                    </React.Fragment>
                ))}
            </Grid>
        </TitledSection>
    );
}
